import { OPEN_NAV, CLOSE_NAV } from '../actions/navActions';

const init = {
  open: false,
};

export default (state = init, action) => {
  switch (action.type) {
    case OPEN_NAV:
      return { open: true };

    case CLOSE_NAV:
      return { open: false };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/navReducer.js